var styles = [".small-card[_ngcontent-%COMP%]{width:720px;padding:48px}@media (max-width:767.98px){.small-card[_ngcontent-%COMP%]{width:unset;padding:24px}}"];
export { styles as styles };
